import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=7b37011b&"
import script from "./MainSidebar.vue?vue&type=script&lang=js&"
export * from "./MainSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports